/*
  Zoohaven: henter det tunge menyinnholdet ved behov.

  HTML-en som sendes med siden inneholder hele menyen som tekst, og
  underkategoriene med ikoner. Menyen er altsa komplett og visuell i det
  oyeblikket den apnes. Det som hentes etterpa er bare det store panelet til
  hoyre — kategoribildene, produktkortene og «Mest solgte».

  Fire ting gjor ventetiden kort:
    1. Henting starter pa hover, tastaturfokus eller fingertrykk, altsa for
       menyen faktisk apnes.
    2. Ikonene i menyen varmes opp nar nettleseren ellers er ferdig, slik at
       de star der med en gang menyen apnes.
    3. De to forste kategoriene forhandshentes nar nettleseren er ledig.
    4. Valgt underkategori beholdes nar det rike innholdet byttes inn, sa
       panelet ikke hopper tilbake til forste element.

  Feiler hentingen, blir tekstversjonen staende. Menyen mister bildene i
  hoyrepanelet, men ingenting slutter a virke.

  Containere merkes i Liquid med:
    data-zh-menu-lazy
    data-zh-menu-handle="<samling-handle>"
    data-zh-menu-view="zhmenu" | "zhmenum"
*/
(function () {
  'use strict';

  var cache = new Map();
  var MAX_PREFETCH = 2;
  var MAX_WARM_ICONS = 60;

  function saveData() {
    var c = navigator.connection;
    if (!c) return false;
    if (c.saveData) return true;
    return c.effectiveType === 'slow-2g' || c.effectiveType === '2g';
  }

  function fragmentUrl(handle, view) {
    var root = '/';
    if (window.Shopify && Shopify.routes && Shopify.routes.root) root = Shopify.routes.root;
    return root.replace(/\/$/, '') + '/collections/' + encodeURIComponent(handle) + '?view=' + encodeURIComponent(view);
  }

  function get(url) {
    var pending = cache.get(url);
    if (!pending) {
      pending = fetch(url, { credentials: 'same-origin' }).then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      });
      cache.set(url, pending);
    }
    return pending;
  }

  // Hvilken underkategori som er valgt i venstrekolonnen, slik at den kan
  // velges igjen etter at innholdet er byttet ut.
  function selectedIndex(el) {
    var toggles = el.querySelectorAll('.menu-sidebar__toggle');
    for (var i = 0; i < toggles.length; i++) {
      if (toggles[i].classList.contains('is-visible')) return i;
    }
    return -1;
  }

  function restoreIndex(el, index) {
    if (index < 1) return;
    var toggles = el.querySelectorAll('.menu-sidebar__toggle');
    if (toggles[index] && !toggles[index].classList.contains('is-visible')) {
      toggles[index].click();
    }
  }

  function load(el) {
    if (!el || el.getAttribute('data-zh-menu-state')) return;

    var handle = el.getAttribute('data-zh-menu-handle');
    var view = el.getAttribute('data-zh-menu-view');
    if (!handle || !view) {
      el.setAttribute('data-zh-menu-state', 'skip');
      return;
    }

    el.setAttribute('data-zh-menu-state', 'loading');
    var url = fragmentUrl(handle, view);
    var index = selectedIndex(el);

    get(url)
      .then(function (html) {
        if (!html || !html.trim()) {
          el.setAttribute('data-zh-menu-state', 'empty');
          return;
        }
        el.innerHTML = html;
        el.setAttribute('data-zh-menu-state', 'loaded');
        restoreIndex(el, index);
        el.dispatchEvent(new CustomEvent('zh:menu-loaded', { bubbles: true }));
      })
      .catch(function () {
        cache.delete(url);
        el.removeAttribute('data-zh-menu-state');
      });
  }

  function loadWithin(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    if (root.matches && root.matches('[data-zh-menu-lazy]')) load(root);
    var nodes = root.querySelectorAll('[data-zh-menu-lazy]');
    for (var i = 0; i < nodes.length; i++) load(nodes[i]);
  }

  // toggle bobler ikke, men capture-fasen fanger det likevel — og fanger
  // ogsa menyer som legges til i DOM-en senere.
  document.addEventListener(
    'toggle',
    function (event) {
      var d = event.target;
      if (!d || d.tagName !== 'DETAILS' || !d.open) return;
      loadWithin(d);
    },
    true
  );

  // Start sa tidlig vi kan: pekeren inn over menypunktet, tastaturfokus,
  // eller fingeren ned pa skjermen. pointerdown gir mobilen et forsprang
  // pa noen hundre millisekunder for skuffen apner seg.
  ['pointerenter', 'pointerdown', 'focusin'].forEach(function (name) {
    document.addEventListener(
      name,
      function (event) {
        var t = event.target;
        if (!t || typeof t.closest !== 'function') return;
        var d = t.closest('details');
        if (d) loadWithin(d);
      },
      true
    );
  });

  // Nar siden ellers er ferdig: varm opp menyikonene og hent de to forste
  // kategoriene. Begge deler ligger utenfor den kritiske stien, og droppes
  // helt pa sparemodus og trege forbindelser.
  function whenIdle(fn) {
    if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: 4000 });
    else setTimeout(fn, 2000);
  }

  function warmUp() {
    if (saveData()) return;

    var containers = document.querySelectorAll('[data-zh-menu-lazy]');
    if (!containers.length) return;

    // 1. Ikonene: samme adresse brukes av bade desktop- og mobilmenyen, sa
    //    hver fil hentes bare en gang.
    var seen = {};
    var count = 0;
    for (var i = 0; i < containers.length && count < MAX_WARM_ICONS; i++) {
      var imgs = containers[i].querySelectorAll('img[src]');
      for (var j = 0; j < imgs.length && count < MAX_WARM_ICONS; j++) {
        var src = imgs[j].currentSrc || imgs[j].src;
        if (!src || seen[src]) continue;
        seen[src] = true;
        count++;
        var warm = new Image();
        warm.decoding = 'async';
        if ('fetchPriority' in warm) warm.fetchPriority = 'low';
        warm.src = src;
      }
    }

    // 2. De to forste kategoriene, i den menyen som faktisk er i bruk.
    var wide = window.matchMedia && window.matchMedia('(min-width: 990px)').matches;
    var view = wide ? 'zhmenu' : 'zhmenum';
    var picked = 0;
    for (var k = 0; k < containers.length && picked < MAX_PREFETCH; k++) {
      var el = containers[k];
      if (el.getAttribute('data-zh-menu-view') !== view) continue;
      if (el.getAttribute('data-zh-menu-state')) continue;
      var handle = el.getAttribute('data-zh-menu-handle');
      if (!handle) continue;
      picked++;
      get(fragmentUrl(handle, view)).catch(function () {});
    }
  }

  if (document.readyState === 'complete') whenIdle(warmUp);
  else window.addEventListener('load', function () { whenIdle(warmUp); });
})();
